export default {
  lang: "CN",
};
